import caretDown from '../../../assets/svg/carat-down.svg';

class Panel {
	constructor(node, opts = {}) {
		this.node = node;
		this.opts = Object.assign(
			{
				titleSelector: '.panels__title',
				contentSelector: '.panels__content',
				openedClass: 'panels__panel--opened',
				transition: 'height 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55), opacity 300ms cubic-bezier(0.68, -0.55, 0.265, 1.55)',
			},
			opts,
		);

		this.opened = this.node.classList.contains(this.opts.openedClass);
		this.title = this.node.querySelector(this.opts.titleSelector);
		this.content = this.node.querySelector(this.opts.contentSelector);

		if (this.title) {
			this.title.insertAdjacentHTML('beforeend', `<span class="panels__toggle">${caretDown}</span>`);
			this.title.addEventListener('click', this.toggle.bind(this));
		}
	}

	open() {
		this.node.classList.add(this.opts.openedClass);

		this.content.style.display = 'block';
		this.content.style.position = 'absolute';
		const height = this.content.offsetHeight;
		this.content.style.position = '';
		this.content.style.height = '0px';
		this.content.style.overflow = 'hidden';

		let transitionend = (e) => {
			this.content.removeEventListener('transitionend', transitionend);
			this.content.removeAttribute('style');
			this.opened = true;
			this.node.dispatchEvent(new CustomEvent('panel:open'));
		}

		this.content.addEventListener('transitionend', transitionend);
		this.content.style.transition = this.opts.transition;

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = `${height}px`;
				this.content.style.opacity = 1;
			})
		});
	}

	close() {
		this.node.classList.remove(this.opts.openedClass);

		this.content.style.display = 'block';
		this.content.style.overflow = 'hidden';
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.content.style.transition = this.opts.transition;

		let transitionend = () => {
			this.content.removeAttribute('style');
			this.opened = false;
			this.content.removeEventListener('transitionend', transitionend);
			this.node.dispatchEvent(new CustomEvent('panel:close'));
		}

		this.content.addEventListener('transitionend', transitionend);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = '0';
				this.content.style.opacity = 0;
			})
		});
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}

class Panels {
	constructor(node, opts = {}) {
		this.node = node;
		this.node.classList.add('panels--interactive');
		this.panels = Array.from(this.node.querySelectorAll('.panels__panel')).map(node => new Panel(node, opts));
	}
}

Panels.instances = Array.from(document.querySelectorAll('.panels')).map(p => new Panels(p));

export default Panels;
